import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { ClickableCard } from 'site-modules/shared/components/inventory/clickable-card/clickable-card';
import { ClickableCardLink } from 'site-modules/shared/components/inventory/clickable-card/clickable-card-link/clickable-card-link';
import { Link } from 'site-modules/shared/components/link/link';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './appraisals-promotion-card.scss';

export const AppraisalsPromotionCard = ({ isChal1 }) => {
  const title = isChal1 ? 'Selling or trading in?' : 'Know your buying power';
  const subtitle = isChal1
    ? 'Know what your car is worth while you shop for your next vehicle.'
    : `Shop smarter by knowing your car’s value.`;
  const cta = isChal1 ? `See my car’s value` : 'Appraise my car';

  return (
    <ClickableCard
      data-tracking-parent="appraisals-inventory-promotion"
      className="appraisals-promotion-card d-flex flex-column usurp-inventory-card rounded-12 bg-white h-100 w-100 justify-content-center align-items-center py-md-0"
      style={{ padding: '56px 20px' }}
    >
      <img
        src={getStaticImageUrl('/appraisal/car-money-img.svg')}
        height={120}
        width={154}
        alt=""
        className="d-block mt-md-0"
        style={{ marginBottom: '40px', marginTop: '56px' }}
        loading="lazy"
      />
      <div className="text-center" style={{ marginBottom: '40px' }}>
        <h2 className="size-24 fw-bold mb-0_5">{title}</h2>
        <h3 className="size-16 fw-normal mb-0">{subtitle}</h3>
      </div>
      <ClickableCardLink
        className="srp-cta text-transform-none fw-semibold mb-md-0 size-16"
        style={{ marginBottom: '56px' }}
        linkComponent={Button}
        color="success"
        tag={Link}
        to="/appraisal/"
        data-tracking-id="appraise_vehicle"
        target="_blank"
        rel="opener" // Using rel="opener" so that session storage is copied to the new tab (see EMO-3139).
      >
        {cta}
      </ClickableCardLink>
    </ClickableCard>
  );
};

AppraisalsPromotionCard.propTypes = {
  isChal1: PropTypes.bool,
};

AppraisalsPromotionCard.defaultProps = {
  isChal1: false,
};
